import type { SVGProps } from 'react';

export const SvgIconArrowCarouselPrev = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
    <path
      d="M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z"
      fill="white"
      stroke="#B0B0B0"
      strokeMiterlimit="10"></path>
    <path d="M26 20L20 24.5L26 29" stroke="#222222" strokeWidth="1.5" strokeLinejoin="round"></path>
    <rect x="2" y="2" width="36" height="36" rx="18" strokeWidth="2"></rect>
  </svg>
);
